import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export function TransportSection({ formData, handleInputChange }) {
  return (
    <Card className="border-slate-200">
      <CardHeader className="pb-4">
        <CardTitle className="text-xl">Transport Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center space-x-4">
          <Label className="text-sm font-medium text-slate-700">
            Is the patient being transported?
          </Label>
          <div className="flex gap-4">
            <button
              type="button"
              onClick={() => handleInputChange('is_transported', true)}
              className={`px-4 py-2 rounded-sm border font-medium text-sm transition-all ${
                formData.is_transported
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'border-slate-300 bg-white text-slate-600 hover:border-slate-400'
              }`}
              data-testid="transport-yes-button"
            >
              YES
            </button>
            <button
              type="button"
              onClick={() => {
                handleInputChange('is_transported', false);
                handleInputChange('transported_by', '');
              }}
              className={`px-4 py-2 rounded-sm border font-medium text-sm transition-all ${
                !formData.is_transported
                  ? 'bg-slate-600 text-white border-slate-600'
                  : 'border-slate-300 bg-white text-slate-600 hover:border-slate-400'
              }`}
              data-testid="transport-no-button"
            >
              NO
            </button>
          </div>
        </div>
        {formData.is_transported && (
          <div className="space-y-2 animate-in fade-in duration-200">
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">
              Transported By
            </Label>
            <Input
              value={formData.transported_by}
              onChange={(e) => handleInputChange('transported_by', e.target.value)}
              placeholder="Enter transport agency/person"
              className="rounded-sm border-slate-300"
              data-testid="transported-by-input"
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
